import { selectStepByOrderIndex } from '../selectors/config'
import type { SetInitialStepAction } from '../types/actions'

import { actionFactory } from './factory'

export const setInitialStep = actionFactory<SetInitialStepAction>(
  (state, { initialStepIndexOverride }) => {
    // skip if navigated path has already been set
    if (state.navigatedPath.length) return

    const initialStepOrderIndex = initialStepIndexOverride ?? 0 // override or the first one
    const initialStep = selectStepByOrderIndex(state, initialStepOrderIndex)

    if (!initialStep) {
      throw new Error('First step not found')
    }

    state.navigatedPath = [initialStep.id]
    state.logicsEngine.locked = false // unlock the logics engine
  },
  'setInitialStep'
)
